var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 923.719,
    height: 775.109,
    viewBox: "0 0 923.719 775.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Project Manager-illustration",
    transform: "translate(-97.062 -130.765)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 618",
    d: "M353.733 216.136a24.251 24.251 0 0 1-24.233-24.215v-36.53a24.251 24.251 0 0 1 24.233-24.251h100.7a24.251 24.251 0 0 1 24.251 24.251v36.529a24.251 24.251 0 0 1-24.251 24.251",
    transform: "translate(134.509)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 619",
    d: "M437.331 166.78a24.251 24.251 0 0 0-24.251 24.251v36.493a24.251 24.251 0 0 0 24.251 24.251H538a24.251 24.251 0 0 0 24.251-24.251v-36.493A24.251 24.251 0 0 0 538 166.78",
    transform: "translate(200.96 28.336)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 620",
    d: "m314.029 152.906 55.844-3.823 1.221-5.385a6.462 6.462 0 0 1 5.385-5.188l17.215-1.185c2.782-.2 4.829 2.244 4.542 5.385l-.377 4.416-.559 6.374-5.008 57.6a8.329 8.329 0 0 1-7.019 7.737l-77.439 5.385c-3.59.233-6.1-2.836-5.762-6.857l4.918-56.688a8.329 8.329 0 0 1 7.037-7.773z",
    transform: "translate(112.679 4.908)",
    style: {
      fill: "#ff9d9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 621",
    d: "m399.309 152.906 55.844-3.823 1.221-5.385a6.462 6.462 0 0 1 5.385-5.188l17.215-1.185c2.782-.2 4.829 2.244 4.541 5.385l-.377 4.416-.556 6.372-5.008 57.6a8.329 8.329 0 0 1-7.019 7.737l-77.439 5.385c-3.59.233-6.1-2.836-5.762-6.857l4.918-56.688a8.329 8.329 0 0 1 7.037-7.773z",
    transform: "translate(180.481 4.908)",
    style: {
      fill: "#90d6d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 622",
    d: "m484.637 152.906 55.844-3.823 1.219-5.383a6.462 6.462 0 0 1 5.385-5.188l17.215-1.185c2.782-.2 4.829 2.244 4.542 5.385l-.377 4.416-.556 6.372-5.009 57.6a8.329 8.329 0 0 1-7.037 7.862l-77.439 5.385c-3.59.233-6.1-2.836-5.762-6.857l4.918-56.688a8.329 8.329 0 0 1 7.055-7.9z",
    transform: "translate(248.307 4.908)",
    style: {
      fill: "#5559bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 623",
    d: "m494.569 153.524-74.01 6.57-.559-6.749a5.744 5.744 0 0 0-6.211-5.636l-22.815 2.028a8.526 8.526 0 0 0-7.18 8.006l-.359 5.672-.521 8.2-4.757 74.046c-.341 5.188 3.2 8.975 7.862 8.634l102.731-9.119a10.77 10.77 0 0 0 9.065-10.124l4.685-72.861c.327-5.22-3.192-9.079-7.931-8.667z",
    transform: "translate(173.178 13.158)",
    style: {
      fill: "#c3e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 624",
    d: "m409.151 153.524-74.01 6.57-.556-6.749a5.744 5.744 0 0 0-6.211-5.636l-22.815 2.028a8.526 8.526 0 0 0-7.18 8.006l-.359 5.672-.5 8.167-4.757 74.046c-.341 5.188 3.2 8.975 7.862 8.634l102.641-9.083a10.77 10.77 0 0 0 9.065-10.124l4.739-72.915c.285-5.169-3.233-9.028-7.919-8.616z",
    transform: "translate(105.281 13.158)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 625",
    d: "m580.715 153.524-74.01 6.57-.556-6.749a5.744 5.744 0 0 0-6.211-5.636l-22.815 2.028a8.526 8.526 0 0 0-7.18 8.006l-.359 5.672-.467 8.167-4.757 74.046c-.341 5.188 3.2 8.975 7.862 8.634l102.605-9.083a10.77 10.77 0 0 0 9.065-10.124l4.685-72.861c.342-5.223-3.177-9.082-7.862-8.67z",
    transform: "translate(241.712 13.158)",
    style: {
      fill: "#9c92dc"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 1",
    cx: 25.759,
    cy: 12.332,
    rx: 25.759,
    ry: 12.332,
    transform: "rotate(-9.05 1543.224 -1559.331)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 626",
    d: "m403.183 216.386 128.131 21.738 4.344-10.088a12.889 12.889 0 0 1 13.8-7.5l39.491 6.7a10.609 10.609 0 0 1 8.76 13.194l-2.15 8.57-3.123 12.422-28.2 112.227A16.155 16.155 0 0 1 546 385.372l-177.71-30.157a13.427 13.427 0 0 1-11.093-16.694l27.77-110.414a16.156 16.156 0 0 1 18.216-11.721z",
    transform: "translate(156.179 67.603)",
    style: {
      fill: "#ff8e00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 627",
    d: "m523.108 372.02-145.059-24.161a11.7 11.7 0 0 1-9.478-14.36l23.695-97.507a12.3 12.3 0 0 1 13.894-9.192l145.058 24.179a11.7 11.7 0 0 1 9.478 14.36L537 362.847a12.3 12.3 0 0 1-13.894 9.173z",
    transform: "translate(165.301 75.929)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 628",
    d: "m604.4 280.754-153.872-26.262 1.346-13.93a13.122 13.122 0 0 0-10.627-14.7l-47.425-8.1c-7.683-1.31-15.563 4.2-17.609 12.314l-2.764 11.237-4.093 16.263-36.943 146.857c-2.585 10.268 3.2 19.943 12.924 21.541L558.7 462.467c9.729 1.652 19.746-5.385 22.277-15.6l36.35-144.52c2.582-10.266-3.198-19.942-12.927-21.593z",
    transform: "translate(136.335 68.719)",
    style: {
      fill: "#fec942"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 629",
    d: "M298.5 333.8c25.131-18.938 45.092-39.1 50.692-46.277s14.737-24.413 16.658-26.208 35.309-15.007 38.45-14.558-.215 15.455-6.5 19.746-10.447 7.629-10.447 7.629l-14.36 54.659s-3.859 2.908-7.09 2.693l-29.439 46.671-36.743-43.655",
    transform: "translate(109.862 91.911)",
    style: {
      fill: "#ff9d9c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 2",
    cx: 25.759,
    cy: 12.332,
    rx: 25.759,
    ry: 12.332,
    transform: "rotate(-9.05 1711.114 -1697.135)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 630",
    d: "M293.529 276.773c4.165 31.5-14.127 41.573-21.936 44.41-1.185.413-2.1.664-2.693.808l-.664.215c-1.669 1.544.377 8.778 3.159 16.335 3.59 9.514 8.239 19.584 8.239 19.584l-60.8 2.549A161.7 161.7 0 0 0 209 313.626l9.819-75.392L282.2 211.11s6.39 9.6 8.509 26.172 15.958 29.762 15.958 29.762c-4.055 7.18-13.138 9.729-13.138 9.729z",
    transform: "translate(38.705 63.581)",
    style: {
      fill: "#ff9d9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 631",
    d: "M719 332.249c-5.224 3.823-5.224 4.165-3.824 12.171s-7.593 24.215-11.829 21.541c-4.793-2.98-13.032-2.98-51.823-3.464-10.573-.126-53.582 49.382-115.835 55.647L534.63 435.2a462.359 462.359 0 0 1-60.924-13.463 442.394 442.394 0 0 1-15.545-4.829 347.917 347.917 0 0 1-45.307-18.31c-5.385-2.693-10.77-5.565-15.958-8.616 0 0 2.441 17.143 6.893 41.412.467 2.585.969 5.224 1.49 7.952s1.149 5.942 1.8 8.975c4.129 20.787 9.442 44.517 15.725 66.6 8.06 28.38 17.771 54.067 28.721 67.35-41.4 44.529-145.065 41.28-189.925 10.764 0 0 9.693-76.021 4.434-85.57-4.542-8.257-57.442-109.7-74.279-142.473l-6.534-16.5c-.844-11.2 5.385-28.29 32.885-33.029a72.268 72.268 0 0 1 7.647-16.335s45.307-9.406 83.937-1.795c0 0 31.9-9.729 49.633-5.565s74.782 37.212 104.364 49.382c23.156 9.55 43.979 18.884 73.849 15.258a139.523 139.523 0 0 0 27.016-6.193c45.576-14.953 98.459-52.882 101.923-55.306s30.606-7.988 35.9-10.77 3.464 14.63-15.312 22.977c0 0 31.988.7 37.553 5.906s-.393 15.386-5.616 19.227z",
    transform: "translate(19.742 121.408)",
    style: {
      fill: "#90d6d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 632",
    d: "M240.381 251.787c-34.537 19.853-58.2 24.2-75.069-3.267s12.386-85.893 37.517-83.488c34.268 3.267 46.241 49.777 53.313 72.071s-15.761 14.684-15.761 14.684z",
    transform: "translate(0 26.889)",
    style: {
      fill: "#011859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 633",
    d: "M273.528 267c-3.734-6.283-26.926-10.878-25.49 9.98 1.113 15.4 12.565 22.169 15.6 22.528 2.082 37.7-49.9 50.962-67.332 21.541s-4.524-73.346 20.033-104.239c17.053-21.541 49.813-30.067 71.156-20.7a32.311 32.311 0 0 1 17.233 17.053 33.134 33.134 0 0 1 1.293 3.59C314.545 245.906 273.528 267 273.528 267z",
    transform: "translate(22.231 48.656)",
    style: {
      fill: "#011859"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 3",
    cx: 3.734,
    cy: 5.242,
    rx: 3.734,
    ry: 5.242,
    transform: "translate(314.607 311.292)",
    style: {
      fill: "#011859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 634",
    d: "M233.59 251.612c0-1.9 15.043-36.637 18.094-43.692",
    transform: "translate(58.255 61.044)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 635",
    d: "M270.758 215.159a50.46 50.46 0 0 1-10.663 2.872c-14.073 2.244-26.316-1.382-27.393-8.114-.969-6.067 7.521-12.565 19.512-15.437",
    transform: "translate(57.491 50.359)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 636",
    d: "M253.281 292.416c-15.868-5.224-21.541-23.138-21.541-23.336 9.837 6.39 15.761 7.18 18.884 6.911l-.467.126c-1.705 1.507.343 8.742 3.124 16.299z",
    transform: "translate(56.785 109.67)",
    style: {
      fill: "#e44543"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 637",
    d: "M224.667 242.249c-.844-8.688 12.817-11.381 18.2-1.939",
    transform: "translate(51.131 82.075)",
    style: {
      stroke: "#e44543",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 638",
    d: "M228 248c3.59 3.07 8.185 3.752 10.375 2.459",
    transform: "translate(53.811 92.91)",
    style: {
      stroke: "#e44543",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 639",
    d: "M417.647 484.188c-41.394 44.535-145.058 41.286-189.917 10.77 0 0 9.693-76.021 4.434-85.57 36.906-4.793 106.07-.969 156.726 7.432 8.06 28.398 17.771 54.08 28.757 67.368z",
    transform: "translate(53.596 219.556)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 640",
    d: "M563.741 332.194c-5.224 3.823-5.224 4.165-3.823 12.171s-7.593 24.215-11.829 21.541c-4.793-2.98-13.032-2.98-51.823-3.464-10.573-.126-53.582 49.382-115.835 55.647l1.8-61.606a139.531 139.531 0 0 0 27.016-6.193c45.576-14.953 98.459-52.882 101.923-55.306s30.606-7.988 35.9-10.77 3.464 14.63-15.312 22.977c0 0 31.988.7 37.553 5.906s-.346 15.255-5.57 19.097z",
    transform: "translate(175.001 121.464)",
    style: {
      fill: "#ff9d9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 641",
    d: "M332 301.446c10.357-5.188 22.707-20 19.746-36.3",
    transform: "translate(136.497 106.545)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 642",
    d: "M447.047 360.73a5.17 5.17 0 0 1-4.865-3.141 372.067 372.067 0 0 0-22.241-43.081 5.226 5.226 0 1 1 8.957-5.385 375.005 375.005 0 0 1 22.9 44.5 5.17 5.17 0 0 1-4.775 7.18z",
    transform: "translate(205.82 139.491)",
    style: {
      fill: "#011859"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4",
    cx: 12.117,
    cy: 12.117,
    r: 12.117,
    transform: "translate(633.57 468.341)",
    style: {
      strokeWidth: ".5px",
      fill: "#fff",
      strokeMiterlimit: 10,
      stroke: "#011859"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 643",
    d: "M296.563 293.28c-27.608 41.807-79.718 30.516-104.113 22.169a49.849 49.849 0 0 1 19.746-7.432s39.222 4.793 84.367-14.737z",
    transform: "translate(25.547 128.91)",
    style: {
      fill: "#7fbfbc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(338.822 437.269)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(356.611 526.662)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(530.121 530.683)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 644",
    d: "M337.23 359.358a8.886 8.886 0 0 1 15.545 4.829",
    transform: "translate(140.655 179.008)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(384.362 476.76)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 9",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(512.332 485.645)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 10",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(437.676 489.361)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 11",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(247.723 494.531)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 645",
    d: "M185.19 320.29a8.9 8.9 0 1 1 6.534 16.5",
    transform: "translate(19.775 149.684)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(301.18 491.336)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(394.702 592.702)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 646",
    d: "M312.528 383.039a8.886 8.886 0 0 1-3.249-17",
    transform: "translate(114.234 186.758)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 14",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(333.921 581.591)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 15",
    cx: 8.886,
    cy: 8.886,
    r: 8.886,
    transform: "translate(283.283 553.588)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 647",
    d: "M230.809 410.327a8.975 8.975 0 0 0-3.429-17.107 8.725 8.725 0 0 0-4.811 1.418",
    transform: "translate(49.494 208.368)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 648",
    d: "M250.658 276.6a31.467 31.467 0 0 1-19.548-8.132",
    transform: "translate(56.284 109.185)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 649",
    d: "M256.09 260.562c.826-.269 9.586-3.59 13.158-9.747 0 0-9.46-11.058-13.158-19.315",
    transform: "translate(76.144 79.792)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 650",
    d: "M383.247 324.34c-2.89 78.677-4.057 97.4-4.057 97.4",
    transform: "translate(174.015 153.605)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 651",
    d: "M369.851 324.34c0 32.311-.269 85.48-2.441 103.646",
    transform: "translate(164.65 153.605)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 652",
    d: "M330.732 369.637c-1.8-.539-31.755-27.2-41.5-41.017",
    transform: "translate(102.492 157.007)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 653",
    d: "M308.594 347.346c-8.688-2.764-11-3.159-19.4-8.006",
    transform: "translate(102.46 165.53)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 654",
    d: "M210.4 310.027a187.009 187.009 0 0 0 79.216-18.6",
    transform: "translate(39.818 127.439)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 655",
    d: "M230.2 409.375S352.587 398.03 420.153 428.8",
    transform: "translate(55.56 219.587)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 656",
    d: "M235.32 412.473c38.145-1.705 101.726 4.99 101.726 4.99",
    transform: "translate(59.631 223.454)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 657",
    d: "M469.66 306a111.872 111.872 0 0 1 15.761.987",
    transform: "translate(245.944 139.022)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 658",
    d: "M469 315.75a887.43 887.43 0 0 1 14.019 2.423",
    transform: "translate(245.419 146.775)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 659",
    d: "M691.585 255.544v129.37H508.49v-129.37a20.984 20.984 0 0 1 20.984-20.984h141.109a20.984 20.984 0 0 1 21.002 20.984z",
    transform: "translate(276.816 82.225)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 660",
    d: "M686.258 254.88v6.66H510.54v-6.66c0-10.07 8.975-18.22 20.14-18.22H666.1c11.147 0 20.158 8.15 20.158 18.22z",
    transform: "translate(278.446 83.894)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 661",
    d: "M529.441 254.371c-10.232-.826-11.058-13.876-3.967-21.128s17.34-2.226 16.515 5.17",
    transform: "translate(286.632 78.372)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 662",
    d: "M545.391 254.371c-10.232-.826-11.057-13.876-3.967-21.128s17.34-2.226 16.515 5.17",
    transform: "translate(299.313 78.372)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 663",
    d: "M580.391 254.371c-10.232-.826-11.058-13.876-3.967-21.128s17.34-2.226 16.514 5.17",
    transform: "translate(327.14 78.372)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 664",
    d: "M594.941 254.371c-10.232-.826-11.057-13.876-3.967-21.128s17.34-2.226 16.515 5.17",
    transform: "translate(338.708 78.372)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 665",
    d: "m568.513 292.078.592.449a14.933 14.933 0 0 1 2.98 3.7 15.657 15.657 0 0 1 1.31 3.59 20.3 20.3 0 0 1 .592 4.99 20.543 20.543 0 0 1-.9 6.211 14.954 14.954 0 0 1-2.333 4.685 15.908 15.908 0 0 1-3.482 3.285 20.071 20.071 0 0 1-4.075 2.226 27.674 27.674 0 0 1-4.344 1.31 31.415 31.415 0 0 1-4.039.646q-1.8.144-3.464.144-5.385 0-16.155-.718a1.185 1.185 0 0 1-.754-.395 1 1 0 0 1-.251-.844l1.275-11.488a1.149 1.149 0 0 1 .413-.754.861.861 0 0 1 .808-.2q10.035 1.454 13.1 1.562.61 0 1.669-.108a24.061 24.061 0 0 0 2.764-.5 6.227 6.227 0 0 0 2.836-1.418 3.338 3.338 0 0 0 1.149-2.585 3.715 3.715 0 0 0-.969-2.621 5.564 5.564 0 0 0-2.513-1.526 17.945 17.945 0 0 0-2.71-.646q-1.167-.162-2.334-.215H544.3a1.1 1.1 0 0 1-.808-.305 1.023 1.023 0 0 1-.305-.754v-11.15a1.024 1.024 0 0 1 .305-.754 1.1 1.1 0 0 1 .808-.305h4.685a8.42 8.42 0 0 0 1.8-.2 11.218 11.218 0 0 0 2.028-.664 3.966 3.966 0 0 0 1.8-1.562 4.6 4.6 0 0 0 .7-2.531 4.506 4.506 0 0 0-.538-2.226 3.952 3.952 0 0 0-1.2-1.4 5.474 5.474 0 0 0-1.562-.7 7.051 7.051 0 0 0-1.364-.287h-.862a131.494 131.494 0 0 0-13.1 1.562 1.149 1.149 0 0 1-.862-.215.862.862 0 0 1-.359-.718l-1.274-11.542a1.006 1.006 0 0 1 .251-.808.951.951 0 0 1 .754-.359q10.77-.772 16.155-.772 1.8 0 3.339.144a29.888 29.888 0 0 1 3.59.592 21.679 21.679 0 0 1 3.841 1.2 16.984 16.984 0 0 1 3.59 2.064 13.62 13.62 0 0 1 2.98 3.034 14.935 14.935 0 0 1 2.01 4.272 19.208 19.208 0 0 1 .772 5.654 21.979 21.979 0 0 1-.305 3.77 14.083 14.083 0 0 1-.754 2.836 18.516 18.516 0 0 1-.9 1.9 5.381 5.381 0 0 1-.772 1.149z",
    transform: "translate(297.229 106.561)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 666",
    d: "M573.25 267.06a21.936 21.936 0 0 1 17.843 0 21.542 21.542 0 0 1 7.18 5.385 25.488 25.488 0 0 1 4.9 9.173 45.163 45.163 0 0 1 0 25.131 25.49 25.49 0 0 1-4.9 9.173 21.541 21.541 0 0 1-7.18 5.385 21.917 21.917 0 0 1-17.843 0 21.538 21.538 0 0 1-7.18-5.385 25.45 25.45 0 0 1-4.9-9.173 45.163 45.163 0 0 1 0-25.131 25.435 25.435 0 0 1 4.9-9.173 21.542 21.542 0 0 1 7.18-5.385zm3.949 37.068a5.259 5.259 0 0 0 9.927 0 25.921 25.921 0 0 0 0-19.746 5.259 5.259 0 0 0-9.927 0 25.922 25.922 0 0 0 0 19.746z",
    transform: "translate(317.281 106.556)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 667",
    d: "M691.585 255.544v129.37H508.49v-129.37a20.984 20.984 0 0 1 20.984-20.984h141.109a20.984 20.984 0 0 1 21.002 20.984z",
    transform: "translate(276.816 82.225)",
    style: {
      strokeWidth: ".75px",
      strokeMiterlimit: 10,
      stroke: "#011859",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 16",
    cx: 46.959,
    cy: 46.959,
    r: 46.959,
    transform: "translate(926.864 412.964)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 17",
    cx: 39.994,
    cy: 39.994,
    r: 39.994,
    transform: "translate(933.829 419.928)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 668",
    d: "m600.59 315.929 23.192 15.635 22.6-26.854",
    transform: "translate(350.04 137.998)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#6b6ce3",
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 391",
    width: 117.361,
    height: 117.45,
    rx: 10.81,
    transform: "translate(843.358 602.252)",
    style: {
      strokeWidth: ".5px",
      fill: "#fff",
      strokeMiterlimit: 10,
      stroke: "#011859"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 18",
    cx: 6.283,
    cy: 6.283,
    r: 6.283,
    transform: "translate(867.771 662.692)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 669",
    d: "M561.366 435.09h1.616a8.814 8.814 0 0 1 8.814 8.814v10.429H552.57V443.9a8.814 8.814 0 0 1 8.814-8.814z",
    transform: "translate(311.862 241.657)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 19",
    cx: 6.283,
    cy: 6.283,
    r: 6.283,
    transform: "translate(895.738 662.692)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 670",
    d: "M576.956 435.09h1.615a8.814 8.814 0 0 1 8.814 8.814v10.429H568.16V443.9a8.814 8.814 0 0 1 8.8-8.814z",
    transform: "translate(324.257 241.657)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 20",
    cx: 6.283,
    cy: 6.283,
    r: 6.283,
    transform: "translate(923.723 662.692)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 671",
    d: "M592.554 435.09h1.616a8.814 8.814 0 0 1 8.814 8.814v10.429H583.74V443.9a8.814 8.814 0 0 1 8.814-8.814z",
    transform: "translate(336.644 241.657)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 21",
    cx: 6.283,
    cy: 6.283,
    r: 6.283,
    transform: "translate(881.754 625.983)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 672",
    d: "M569.174 414.63h1.616a8.814 8.814 0 0 1 8.814 8.814v10.429H560.36v-10.429a8.814 8.814 0 0 1 8.814-8.814z",
    transform: "translate(318.055 225.39)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 22",
    cx: 6.283,
    cy: 6.283,
    r: 6.283,
    transform: "translate(909.739 625.983)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 673",
    d: "M584.746 414.63h1.616a8.814 8.814 0 0 1 8.814 8.814v10.429H575.95v-10.429a8.814 8.814 0 0 1 8.8-8.814z",
    transform: "translate(330.45 225.39)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 392",
    width: 117.361,
    height: 117.45,
    rx: 10.81,
    transform: "translate(773.889 506.306)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 674",
    d: "M566.966 408.345a29.565 29.565 0 1 1-13.032-50.262l-9.586 31.844 31.593-7.432a29.511 29.511 0 0 1-8.975 25.849z",
    transform: "translate(283.734 179.727)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 675",
    d: "M564.769 376.919 537 383.489l8.419-27.949a35.721 35.721 0 0 1 19.44 21.379z",
    transform: "translate(299.483 178.41)",
    style: {
      fill: "#6b6ce3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 393",
    width: 117.361,
    height: 117.45,
    rx: 10.81,
    transform: "translate(673.725 574.267)",
    style: {
      strokeWidth: ".5px",
      fill: "#fff",
      strokeMiterlimit: 10,
      stroke: "#011859"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 394",
    width: 54.282,
    height: 72.197,
    rx: 3.78,
    transform: "translate(705.264 599.075)",
    style: {
      fill: "#ffc5cb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 395",
    transform: "translate(718.494 594.713)",
    style: {
      fill: "#6b6ce3"
    },
    d: "M0 0h27.823v8.006H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 676",
    d: "M468.85 403.178a39.372 39.372 0 0 0 2.908 2.926c0-.2 5.385-5.834 5.385-5.834",
    transform: "translate(245.3 213.973)",
    style: {
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    transform: "translate(729.282 618.282)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0h16.335"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 677",
    d: "M468.85 408.568a39.408 39.408 0 0 0 2.908 2.926c0-.2 5.385-5.834 5.385-5.834",
    transform: "translate(245.3 218.258)",
    style: {
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 2",
    transform: "translate(729.282 627.975)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0h13.445"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 678",
    d: "M468.85 413.958a39.373 39.373 0 0 0 2.908 2.926c0-.2 5.385-5.834 5.385-5.834",
    transform: "translate(245.3 222.544)",
    style: {
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3",
    transform: "translate(729.282 637.651)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0h16.335"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 4",
    transform: "translate(729.282 647.326)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0h21.361"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 5",
    transform: "translate(729.282 657.001)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0h9.155"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 679",
    d: "M233.26 453.792c4.218-5.924 13.391-5.188 9.173 2.962s3.59 8.886 5.78 6.66",
    transform: "translate(57.993 253.435)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 680",
    d: "M241.854 421.423c7.18-.736 12.709 6.66 3.823 8.85s-4.326 8.527-1.2 8.724",
    transform: "translate(63.741 230.75)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 681",
    d: "M300.9 443.578c-6.678 2.854-14.127-2.567-6.283-7.306s1.6-9.424-1.454-8.688",
    transform: "translate(104.102 235.628)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 682",
    d: "M321.125 420.475c.431 7.18-7.18 12.44-8.975 3.464s-8.347-4.685-8.67-1.562",
    transform: "translate(113.822 228.52)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 683",
    d: "M268.58 440.29c2.208 6.929-3.877 13.822-7.862 5.583s-9.245-2.477-8.8.628",
    transform: "translate(72.809 245.791)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 684",
    d: "M270.242 430.255c-4.6-5.636-1.454-14.36 5.277-8.06s9.5-1.077 7.952-3.805",
    transform: "translate(85.669 228.379)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 685",
    d: "M276 450.968c7.073-1.669 13.481 4.936 4.936 8.275s-3.2 8.975 0 8.814",
    transform: "translate(91.974 254.069)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 686",
    d: "M318.223 443.63c6.48 3.285 7.18 12.458-1.544 9.514s-8.239 4.847-5.708 6.714",
    transform: "translate(118.501 248.447)",
    style: {
      stroke: "#0038ad",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 608",
    d: "M7207.007 39.719s-32.19-215.412-144.421-227.83c-79.753-8.825-317.843 91.571-317.843 91.571V39.719z",
    transform: "translate(-6647.682 866.154)",
    style: {
      fill: "#f1f3fe"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLeft);
export default __webpack_public_path__ + "static/media/login-left.484b9d6d3f3310bc0a1581fa7d869d4d.svg";
export { ForwardRef as ReactComponent };